import type { MatchSuggestion } from "../../platform/matcher-transport.js";

/** Folds match.suggestion frames, deduped by subject (last-write-wins on
 *  updatedAt). near() filters to currently-open requests (authoritative display
 *  cross-check against HelpStore) and ranks best-first. */
export class MatchStore {
  #bySubject = new Map<string, MatchSuggestion>();

  /** Returns true if this is the first match seen for the subject (toast trigger). */
  upsert(m: MatchSuggestion): boolean {
    const existing = this.#bySubject.get(m.subject);
    const isNew = existing === undefined;
    if (existing === undefined || m.updatedAt >= existing.updatedAt) {
      this.#bySubject.set(m.subject, m);
    }
    return isNew;
  }

  drop(subject: string): void {
    this.#bySubject.delete(subject);
  }

  get(subject: string): MatchSuggestion | undefined { return this.#bySubject.get(subject); }

  /** Ranked matches whose request is still open (per HelpStore's open set). */
  near(openSubjects: ReadonlySet<string>): MatchSuggestion[] {
    return [...this.#bySubject.values()]
      .filter((m) => openSubjects.has(m.subject))
      .sort((a, b) => (b.rank - a.rank) || a.subject.localeCompare(b.subject));
  }
}
